import React, {useEffect, useState} from 'react'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';





const GreenRadio = withStyles({
    root: {
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);


const Index = (props)=>{

  const [type, setType] = useState('')

  useEffect(()=>{
    setType(props.titleValue)
  },[props.titleValue])

    return(
        <div className="dashboard-textfield-container">
            <div className="dashboard-textfield-title">
                {/* <span className="general-span-text">sample</span> */}
            </div>
            <FormControl component="fieldset" style={{
                display: 'flex',
                marginRight: 'auto'}}>
                  <RadioGroup  
                    style={{
                      display: 'flex',
                      width: '100%',
                      flexDirection: 'row',
                  }}
                    aria-label="gender" 
                    name="gender1" 
                    value={type} 
                    onChange={props.handleTitleChange}>
                    <FormControlLabel value="Local" control={<GreenRadio />} label="Local" labelPlacement="bottom"/>
                    <FormControlLabel value="Foreigner" control={<GreenRadio />} label="Foreigner" labelPlacement="bottom"/>
                  </RadioGroup>
              </FormControl>
        </div>

    )
}

export default Index